import { render } from "./ReportCardGrid.vue?vue&type=template&id=5e879fec"
import script from "./ReportCardGrid.vue?vue&type=script&lang=js"
export * from "./ReportCardGrid.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__